import { render, staticRenderFns } from "./UploadFiles2.vue?vue&type=template&id=0457fc0c&"
import script from "./UploadFiles2.vue?vue&type=script&lang=js&"
export * from "./UploadFiles2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports